
import { AsyncStorage } from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, autoRehydrate } from 'redux-persist';
import reducers from '../reducers';
import array from './array';

// let isDebuggingInChrome = !!window.navigator.userAgent;



export default function configureStore(onComplete:()=>void):any {
  // const enhancer = compose(
  //   applyMiddleware(thunk, promise),
  //   devTools({
  //     name: 'propress', realtime: true,
  //   }),
  // );
  let createAppStore = applyMiddleware(thunk, array)(createStore);

  // AsyncStorage.removeItem('reduxPersist:firstRun');
  // AsyncStorage.removeItem('reduxPersist:security');
  // AsyncStorage.removeItem('reduxPersist:publications');
  // AsyncStorage.removeItem('reduxPersist:drawer');
  // AsyncStorage.removeItem('reduxPersist:navigations');
  // AsyncStorage.removeItem('reduxPersist:appConfig');
  // console.warn("ic");
  // const store = createStore(reducer);
    const store = compose(autoRehydrate())(createAppStore)(reducers);
    persistStore(store, { storage: AsyncStorage }, onComplete);
    // if (isDebuggingInChrome) {
    //     window.store = store;
    // }
  return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js